import React from 'react'
import { AdvertDiv } from './style'

function Advert() {
    return (
        <AdvertDiv className="container-fluid">
          
          <marquee width="95%" direction="right" scrollamount="17"  height="100px">

            <div className="row">
                <div className="col-md-2 col-sm-12">
                    <h3>google</h3>
                </div>
                <div className="col-md-2 col-sm-12">
                    <h3>semicolon</h3>
                </div>
                <div className="col-md-2 col-sm-12">
                    <h3>google</h3>
                </div>
                <div className="col-md-2 col-sm-12">
                    <h3>semicolon</h3>
                </div>
                <div className="col-md-2 col-sm-12">
                    <h3>google</h3>
                </div>
                <div className="col-md-2 col-sm-12">
                    <h3>semicolon</h3>
                </div>  
              

            </div>
</marquee>
           
           
           
        </AdvertDiv>
    )
}

export default Advert
